export const validateMinLength = (name, value, min) => {
    if (value.trim().length < min) {
        return `Your ${name} needs to be at least ${min} characters.`
    }
    return '';
}

export const validateAddress = (value) => {
    const address = value.trim();

    if (!address) {
        return "Address is required.";
    }

    if (address.length < 10) {
        return "Please enter a complete address.";
    }

    return "";
};

export const validatePhoneNumber = (value, min, max) => {
    if (value.trim().length < min) {
        return `Your telephone number needs to be at least ${min} digits.`
    }

    if (value.trim().length > max) {
        return `Your telephone number must be no longer than ${max} digits.`
    }

    if (!value.trim().startsWith("0")) {
        return `Your telephone number must start with 0.`
    }

    return '';
}

export const validateEmail = (value) => {
    if (!value) return "Email is required";
    const emailPattern = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/;
    if (!emailPattern.test(value)) return "Please enter a valid email address";
    return "";
}

export const validateWebsite = (value) => {
  if (!value.trim()) {
    return "Website is required.";
  }

  const website = value.startsWith("http")
    ? value
    : `https://${value}`;

  try {
    const url = new URL(website);

    if (!url.hostname.includes(".")) {
      return "Please enter a valid website address.";
    }

    return "";
  } catch {
    return "Please enter a valid website address.";
  }
};